// extracted by mini-css-extract-plugin
export default {"checkbox_checked":"AddToDo_checkbox_checked__D-iAa","Mui-checked":"AddToDo_Mui-checked__UuImI","dropdownMenu":"AddToDo_dropdownMenu__0OF9s"};